<template>
    <md-card-content>
        <div class="md-layout">
            <div class="md-layout-item md-size-50">
                <span class="font-medium">Document {{ document.type === 1 ? 'non' : '' }} visible par le client</span>
            </div>
        </div>
        <div class="md-layout mt-2">
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Nom</label>
                    <md-input v-model="document.name" name="name" type="text" required></md-input>
                    <validation-error :errors="apiValidationErrors.name"/>
                </md-field>
            </div>
        </div>
        <div class="md-layout mt-4">
            <div class="md-layout-item md-size-50">
                <md-field class="md-invalid">
                    <label>Fichier</label>
                    <md-file name="file" @change="selectFile"
                             accept=".doc,.docx,.pdf,.xls,.xlsx,.jpg,.jpeg,.gif,.png"></md-file>
                    <validation-error marge="ml-2" :errors="apiValidationErrors.file"/>
                </md-field>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "DocumentForm",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        document: Object,
        errors: Array
    },
    methods: {
        selectFile(e) {
            this.resetApiValidation();
            const file = e.target.files[0]
            if (file.size > 5242880) {
                this.setApiValidation([{
                    detail: 'Le fichier est trop volumineux. Taille maximale : 5 Mo.',
                    source: { pointer: '/data/attributes/file' }
                }]);
            }
            this.document.file = file
        }
    },
    watch: {
        errors: function (newVal, oldVal) {
            this.resetApiValidation();
            if (newVal) {
                this.setApiValidation(newVal);
            }
        }
    }
}
</script>

<style scoped>

</style>